import { Button, Col, Collapse, Row, Spinner } from "react-bootstrap";
import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Icon } from "@lomarengas/design-system";
import BookingRowsTable from "./BookingRowsTable";
import { useAuthUser } from "../../features/auth/authHooks";
import {
  getAccommodationsCalendarBookingsAsync,
  getBookingsStartingInSevenDays,
  selectAccommodationsBookingItems,
  selectBookingItemsStartingInSevenDays,
  selectBookingsStartingInSevenDaysStatus,
} from "./bookingsSlice";
import { LOADING_STATUS } from "../../common/constants";

const BookingsStartingInSevenDays = () => {
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const { isOwnerUser } = useAuthUser();
  const [
    bookingsStartingInsSvenDayBookingsToLoad,
    setBookingsStartingInsSvenDayBookingsToLoad,
  ] = useState(false);

  const bookingsItemsStartingInSevenDays = useAppSelector((state) =>
    selectBookingItemsStartingInSevenDays(state),
  );
  const bookingsItemsStartingInSevenDaysStatus = useAppSelector((state) =>
    selectBookingsStartingInSevenDaysStatus(state),
  );
  const initFetch = () => {
    if (!bookingsStartingInsSvenDayBookingsToLoad) {
      return;
    }
    // Fetch bookings for this ownerid for bookings that start in 7 days
    dispatch(getBookingsStartingInSevenDays());
  };
  useEffect(() => {
    initFetch();
  }, [bookingsStartingInsSvenDayBookingsToLoad]);

  return (
    <>
      <Button
        onClick={() =>
          setBookingsStartingInsSvenDayBookingsToLoad(
            !bookingsStartingInsSvenDayBookingsToLoad,
          )
        }
        aria-controls="example-collapse-text"
        aria-expanded={bookingsStartingInsSvenDayBookingsToLoad}
        variant="outline-blue"
        className="w-100 mt-16"
      >
        <Icon Name="chevron-expand" /> Näytä 7 päivän sisällä alkavat varaukset
      </Button>

      {bookingsStartingInsSvenDayBookingsToLoad && (
        <>
          {bookingsItemsStartingInSevenDaysStatus === LOADING_STATUS.LOADING ? (
            <div className="d-flex gap-16 align-items-center mt-16">
              <Spinner animation="border" />
              <span>Ladataan varauksia…</span>
            </div>
          ) : bookingsItemsStartingInSevenDaysStatus === LOADING_STATUS.IDLE &&
            bookingsItemsStartingInSevenDays != null &&
            bookingsItemsStartingInSevenDays.length > 0 ? (
            <BookingRowsTable
              bookings={bookingsItemsStartingInSevenDays}
              clearAllPastBookings={true}
              showCottageName={true}
              onICalSaved={() => dispatch(getBookingsStartingInSevenDays())}
            />
          ) : (
            <p className="mt-16">
              Ei varauksia alkamassa seuraavan 7 päivän aikana.
            </p>
          )}
        </>
      )}
    </>
  );
};

export default BookingsStartingInSevenDays;
